module.exports = __webpack_public_path__ + "img/15.1177a983.png";